import axios from "axios";

// Ajusta aquí tu baseURL si ya la manejas en otro archivo.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://localhost:7064",
});

export const lecheApi = {
  listarPorAnimal: async (animalId) => {
    const { data } = await api.get(`/api/Leche/porAnimal/${animalId}`);
    return data;
  },

  crear: async (payload) => {
    const { data } = await api.post(`/api/Leche`, payload);
    return data;
  },

  editar: async (id, payload) => {
    const { data } = await api.put(`/api/Leche/${id}`, payload);
    return data;
  },

  eliminar: async (id) => {
    await api.delete(`/api/Leche/${id}`);
  },

  resumen: async (animalId) => {
    const { data } = await api.get(`/api/Leche/resumen/${animalId}`);
    return data;
  },
};
